var _path, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 19.9872C14.7982 19.8317 12.8022 18.7412 11.4988 16.9987C11.0853 16.4459 11.1982 15.6625 11.751 15.249C12.3038 14.8355 13.0872 14.9484 13.5007 15.5012C14.3697 16.6629 15.7003 17.3899 17.1474 17.4936C18.5944 17.5972 20.0151 17.0672 21.0409 16.0411L24.7756 12.3066C26.6705 10.3447 26.6434 7.22614 24.7147 5.29747C22.7861 3.36881 19.6675 3.34171 17.7186 5.22391L15.5686 7.36141C15.079 7.84814 14.2875 7.84584 13.8008 7.35626C13.3141 6.86668 13.3164 6.07523 13.8059 5.5885L15.9689 3.43835C18.9117 0.596057 23.5895 0.636705 26.4825 3.52971C29.3755 6.42271 29.4162 11.1005 26.5586 14.0588L22.8088 17.8087C21.2703 19.3477 19.1393 20.1426 16.9688 19.9872ZM13.0307 10.0128C15.2013 10.1682 17.1973 11.2587 18.5007 13.0013C18.9142 13.5541 18.8013 14.3374 18.2485 14.7509C17.6957 15.1645 16.9123 15.0515 16.4988 14.4987C15.6298 13.337 14.2992 12.61 12.8521 12.5064C11.4051 12.4027 9.98443 12.9327 8.95863 13.9589L5.22386 17.6934C3.329 19.6553 3.3561 22.7738 5.28477 24.7025C7.21344 26.6311 10.332 26.6582 12.2784 24.7786L14.4159 22.6411C14.904 22.153 15.6955 22.153 16.1836 22.6411C16.6718 23.1293 16.6718 23.9207 16.1836 24.4089L14.0306 26.5616C11.0878 29.4039 6.41 29.3632 3.517 26.4702C0.623997 23.5772 0.583348 18.8994 3.44087 15.9411L7.19071 12.1913C8.72916 10.6523 10.8602 9.85732 13.0307 10.0128Z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 19.9872C14.7982 19.8317 12.8022 18.7412 11.4988 16.9987C11.0853 16.4459 11.1982 15.6625 11.751 15.249C12.3038 14.8355 13.0872 14.9484 13.5007 15.5012C14.3697 16.6629 15.7003 17.3899 17.1474 17.4936C18.5944 17.5972 20.0151 17.0672 21.0409 16.0411L24.7756 12.3066C26.6705 10.3447 26.6434 7.22614 24.7147 5.29747C22.7861 3.36881 19.6675 3.34171 17.7186 5.22391L15.5686 7.36141C15.079 7.84814 14.2875 7.84584 13.8008 7.35626C13.3141 6.86668 13.3164 6.07523 13.8059 5.5885L15.9689 3.43835C18.9117 0.596057 23.5895 0.636705 26.4825 3.52971C29.3755 6.42271 29.4162 11.1005 26.5586 14.0588L22.8088 17.8087C21.2703 19.3477 19.1393 20.1426 16.9688 19.9872ZM13.0307 10.0128C15.2013 10.1682 17.1973 11.2587 18.5007 13.0013C18.9142 13.5541 18.8013 14.3374 18.2485 14.7509C17.6957 15.1645 16.9123 15.0515 16.4988 14.4987C15.6298 13.337 14.2992 12.61 12.8521 12.5064C11.4051 12.4027 9.98443 12.9327 8.95863 13.9589L5.22386 17.6934C3.329 19.6553 3.3561 22.7738 5.28477 24.7025C7.21344 26.6311 10.332 26.6582 12.2784 24.7786L14.4159 22.6411C14.904 22.153 15.6955 22.153 16.1836 22.6411C16.6718 23.1293 16.6718 23.9207 16.1836 24.4089L14.0306 26.5616C11.0878 29.4039 6.41 29.3632 3.517 26.4702C0.623997 23.5772 0.583348 18.8994 3.44087 15.9411L7.19071 12.1913C8.72916 10.6523 10.8602 9.85732 13.0307 10.0128Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.32279,
    y1: 14.9997,
    x2: 28.6772,
    y2: 14.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    stopColor: "#57D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D43F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkpin);
export default __webpack_public_path__ + "static/media/linkpin.7aa773a545fd6b0c142360289bf11702.svg";
export { ForwardRef as ReactComponent };